import request from "../utils/request";

/**
 * Cache API wrapper
 */
export const CACHE_API = {
    /**
     * Cache listesini döndürür
     * @param {Object} filters - Filter options
     * @param {Object} cursor - Pagination cursor
     * @param {Object} sort - Sort options
     * @returns {Promise}
     */
    listCaches(filters = {}, cursor = { page: 1, perPage: 20 }, sort = {}) {
        return request({
            url: "/cache/list",
            method: "post",
            data: {
                filters,
                cursor,
                sort,
            },
            timeout: 30000,
        }).then((response) => response.data);
    },

    /**
     * Cache yazar (UI'dan kullanım için)
     * @param {string} key - Cache key
     * @param {*} value - Cache value
     * @param {Object} options - Cache options
     * @returns {Promise}
     */
    writeCache(key, value, options = {}) {
        return request({
            url: "/cache/write",
            method: "post",
            data: {
                key,
                value,
                ...options,
            },
            timeout: 10000,
        }).then((response) => response.data);
    },

    /**
     * Cache value'sunu günceller
     * @param {string} cacheId - Cache document ID
     * @param {*} value - New value
     * @param {string} dataType - Data type
     * @returns {Promise}
     */
    updateCacheValue(cacheId, value, dataType) {
        return request({
            url: `/cache/${cacheId}/update`,
            method: "post",
            data: {
                value,
                dataType,
            },
            timeout: 10000,
        }).then((response) => response.data);
    },

    /**
     * Cache geçerlilik süresini uzatır
     * @param {string} cacheId - Cache document ID
     * @param {Date} expiresAt - New expiration date
     * @returns {Promise}
     */
    extendCache(cacheId, expiresAt) {
        return request({
            url: `/cache/${cacheId}/extend`,
            method: "post",
            data: {
                expiresAt,
            },
            timeout: 10000,
        }).then((response) => response.data);
    },

    /**
     * Cache siler
     * @param {string} cacheId - Cache document ID
     * @returns {Promise}
     */
    deleteCache(cacheId) {
        return request({
            url: `/cache/${cacheId}`,
            method: "delete",
            timeout: 10000,
        }).then((response) => response.data);
    },

    /**
     * Birden fazla cache'i siler
     * @param {Array<string>} cacheIds - Cache document IDs
     * @returns {Promise}
     */
    bulkDeleteCaches(cacheIds) {
        return request({
            url: "/cache/bulk-delete",
            method: "post",
            data: {
                cacheIds,
            },
            timeout: 30000,
        }).then((response) => response.data);
    },

    /**
     * Belirli aktörün tüm cache'lerini siler
     * @param {string} actorType - Actor type (automation/chatbot/user/api)
     * @param {string} actorId - Actor ID
     * @returns {Promise}
     */
    deleteCachesByActor(actorType, actorId) {
        return request({
            url: "/cache/delete-by-actor",
            method: "post",
            data: {
                actorType,
                actorId,
            },
            timeout: 30000,
        }).then((response) => response.data);
    },

    /**
     * Pattern ile eşleşen cache'leri siler
     * @param {string} pattern - Wildcard pattern
     * @returns {Promise}
     */
    deleteCachesByPattern(pattern) {
        return request({
            url: "/cache/delete-by-pattern",
            method: "post",
            data: {
                pattern,
            },
            timeout: 30000,
        }).then((response) => response.data);
    },

    /**
     * Cache'i süresiz yapar (expiresAt = null)
     * @param {string} cacheId - Cache document ID
     * @returns {Promise}
     */
    makeNeverExpire(cacheId) {
        return request({
            url: `/cache/${cacheId}/never-expire`,
            method: "post",
            timeout: 10000,
        }).then((response) => response.data);
    },
};

export default CACHE_API;


